// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1d7uC","list":"styles_list__3PZPT"};